import "@aws-amplify/ui-react/styles.css";
import {
  withAuthenticator,
  Button,
  Heading,
  Image,
  View,
  Text,
  TextField,
  Card,
  Flex,
  Message,
} from "@aws-amplify/ui-react";
import { APadded, NextBackButtonHolder } from "../components/layout";
import { AH2 } from "../components/text";
import { Navigate, useNavigate } from "react-router-dom";
import { INutritionData } from "../interfaces";
import { GlobalContext } from "../context/global";
import { useContext } from "react";
import styled from "styled-components";

const Spacer = styled(View)`
margin-top:7px;
`

const BigSpacer = styled(View)`
margin-top:47px;
`

export const ViewEventBasketWater = () => {
  const {nutritionData, addSaltCapsule, addSaltChew, basket} = useContext(GlobalContext);
  const navigate = useNavigate();

    const haveBasket = (nutritionData as any).hasLoaded
    if (!haveBasket) {
      return <Navigate to="/" />
    }
    
    const nutrition = nutritionData as INutritionData

    const goToNext = () => {
      navigate("/event/new/1/basket/checkout")
    }

    const goBack = () => {
      navigate("/event/new/1/basket/salt")
    }
    
    return <APadded>
    <AH2>Hydration</AH2>
    <Spacer/>
    <Message
        variation="filled"
        colorTheme="success"
        isDismissible={false}
        heading="">
        This is how much you should drink. Water will do.
    </Message>
    <BigSpacer/>
    <View>
      <Text>Recommended H2O: <b>{nutrition.depletion.waterMl}ml</b></Text>
    </View>
    <BigSpacer/>
    <NextBackButtonHolder>
       <Button onClick={goBack}>
              ‹ Back 
            </Button>
            &nbsp;
      <Button onClick={goToNext}>
                Next ›
            </Button>
        </NextBackButtonHolder>
    </APadded>
}